export const downloadBlob = (content, filename) => {
    // create "a" HTML element with href to file & click
    const href = URL.createObjectURL(content)
    const link = document.createElement('a')
    link.href = href
    link.setAttribute('download', filename)
    document.body.appendChild(link)
    link.click()

    // clean up "a" element & remove ObjectURL
    document.body.removeChild(link)
    URL.revokeObjectURL(href)
}


export const createFileName = (title, extension) => {
  return `${title.replace(' ', '-')}-${Date.now()}.${extension}`.toLowerCase()
} 


export const downloadXlsx = (content, title) => {
  const blobObj = new Blob([content], { 'type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
  const filename = createFileName(title, 'xlsx')
  return downloadBlob(blobObj, filename)
}
